import { format } from 'date-fns';
import { enUS, sv } from 'date-fns/locale';

export function formatDateWithLanguage(date, pattern, language) {
    let locale = sv;
    if (language === 'en') {
        locale = enUS;
    }

    return format(date, pattern, {locale});
}

export function parseDate(date) {
    if (typeof (date) === 'string') {
        return new Date(date);
    }

    if (typeof (date) === 'number') {
        return new Date(date * 1000);
    }

    return date;
}
